import { autoserialize, autoserializeAs } from 'cerialize';

export class EmergencyTemplateLabel {
  @autoserialize id!: number;
  @autoserialize label!: string;
  @autoserialize level!: number;
  @autoserialize priority!: number;
  @autoserializeAs('hex_color')  color!: string;
}

export class EmergencyTemplate {
  @autoserialize id!: string;
  @autoserialize name!: string;
  @autoserializeAs(EmergencyTemplateLabel) labels!: Array<EmergencyTemplateLabel>;
}
